import(/* webpackMode: "eager", webpackExports: ["GuidesView"] */ "/app/app/(v3)/guides/[slug]/screens/GuidesView/GuidesView.tsx");
